import { configureStore } from "@reduxjs/toolkit";
import widenSearchReducer from "./reducers/widenSearchSlice";
export default configureStore({
  reducer: {
    widenSearch: widenSearchReducer
  },
  devTools: process.env.NODE_ENV === 'development'
});